import { render, staticRenderFns } from "./ModalMakePublic.vue?vue&type=template&id=28dbafd4&scoped=true"
import script from "./ModalMakePublic.vue?vue&type=script&lang=js"
export * from "./ModalMakePublic.vue?vue&type=script&lang=js"
import style0 from "./ModalMakePublic.vue?vue&type=style&index=0&id=28dbafd4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28dbafd4",
  null
  
)

export default component.exports